class ResumeCartProduct {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('.pop-up-2').forEach((item) => {
            new ResumeCartProductItem(item)
        })
    }
}

class ResumeCartProductItem {
    constructor(el) {
        this.el = el
        this.timer = null
        this.mouseMoveHandler = null
        this._init()
    }
    _init() {
        setTimeout(() => {
            this.el.classList.add('open');
        }, 300);

        document.body.addEventListener('click', (e) => {
            if (e.target.closest('.pop-up-2') === null) {
                this.hide()
            }
        });

        this.mouseMoveHandler = this.mouseMove.bind(this)
        document.body.addEventListener('mousemove', this.mouseMoveHandler);
    }

    mouseMove() {
        document.body.removeEventListener('mousemove', this.mouseMoveHandler)
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.hide()
        }, 5000);
    }

    hide() {
        this.el.classList.add('hide')
        setTimeout(() => {
            this.el.remove()
        }, 400);
    }
}

export default ResumeCartProduct